import { render, staticRenderFns } from "./CollapseTable.vue?vue&type=template&id=da5b5b30&scoped=true&"
import script from "./CollapseTable.vue?vue&type=script&lang=js&"
export * from "./CollapseTable.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTable.vue?vue&type=style&index=0&id=da5b5b30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5b5b30",
  null
  
)

export default component.exports